import * as React from 'react';
import { useEffect, useState } from 'react';
import { SelectWidget } from '../../../../widgets/select/SelectWidget';
import { styled } from '../../../../theme';
import * as _ from 'lodash';

export interface CommonRepoSelectProps {
  setProperties: (props: { repo?: string; create?: boolean }) => any;
  repo?: string;
  repos: { value: string; label: string }[] | null;
}

export function normaliseRepoName(name?: string): string | undefined {
  if (!name) {
    return;
  }
  // quotes and apostrophes
  name = name.replace(/['"`]/g, '');

  // add dashes
  return _.kebabCase(name).toLowerCase();
}

export const AdvancedSelect: React.FC<CommonRepoSelectProps & { appName: string; groupingName: string }> = (props) => {
  const [inputValue, setInputValue] = useState('');
  const isCustomRepo = (repo?: string) => {
    return !props.repos?.find((r) => r.value === repo);
  };
  const repo = normaliseRepoName(props.repo) || normaliseRepoName(props.appName);

  useEffect(() => {
    if (!repo) {
      return;
    }
    props.setProperties({
      repo,
      create: isCustomRepo(repo)
    });
  }, [repo, props.repos]);

  const isCustom = !props.repos?.find((r) => r.value === repo);
  const noExistingRepos = !props.repos || props.repos.length == 0;

  return (
    <>
      <S.SelectLabel>
        {isCustom
          ? `The below repo will automatically be created in the selected ${props.groupingName}.`
          : 'The existing repo below will be used.'}
      </S.SelectLabel>
      <SelectWidget
        onChange={(v) => {
          const selectedRepo = (v as any).value;
          props.setProperties({
            repo: normaliseRepoName(selectedRepo),
            create: isCustomRepo(selectedRepo)
          });
        }}
        value={{
          value: repo || '',
          label: repo || ''
        }}
        placeholder="Select repository"
        options={props.repos || []}
        isLoading={!props.repos}
        hideDropdown={noExistingRepos}
        defaultInputValue={repo}
        inputValue={inputValue}
        onBlur={() => {
          if (inputValue) {
            props.setProperties({
              repo: normaliseRepoName(inputValue),
              create: isCustomRepo(inputValue)
            });
          }
        }}
        onInputChange={(value) => {
          setInputValue(value);
        }}
        noOptionsMessage={(payload) => {
          if (!payload.inputValue) {
            return null;
          }
          return `Create new repo ${normaliseRepoName(payload.inputValue)}`;
        }}
      />
    </>
  );
};

namespace S {
  export const SelectLabel = styled.div`
    color: ${(p) => p.theme.text.secondary};
    padding-bottom: 8px;
  `;
}
